// extracted by css-extract-rspack-plugin
export default {"product":"Product-module__product--sM8cz"};